if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");

        // Local confirmation elements and logic
        this.localConfirmModal = document.querySelector(
          ".local-confirm-modal-wrapper"
        );
        this.localConfirmModalCheckbox = undefined;
        const submit = this.querySelector('[type="submit"]');
    
        if (this.localConfirmModal && submit.classList.contains('collection-fresh-flowers')) {
          this.localConfirmModalCheckbox = this.localConfirmModal.querySelector(
            "#local-confirm-checkbox"
          );
          this.localConfirmModalCloseButton =
            this.localConfirmModal.querySelector(".local-confirm-modal__close");

          // Listen to checked state
          this.localConfirmModalCheckbox.addEventListener("change", (event) => {
            if (event.currentTarget.checked) {
              this.submitForm();
              this.localConfirmModal.style.display = "none";
            }
          });

          // Listen for modal close
          this.localConfirmModalCloseButton.addEventListener("click", () => {
            this.localConfirmModal.style.display = "none";
          });
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submit = this.querySelector('[type="submit"]');

        if (this.localConfirmModal && submit.classList.contains('collection-fresh-flowers')) {
          // Ensure it's unchecked by default
          console.log('foo');
          this.localConfirmModalCheckbox.checked = false;
          this.localConfirmModal.style.display = "block";
        } else {
          this.submitForm();
        }
      }

      submitForm() {
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();
        this.cartNotification.setActiveElement(document.activeElement);

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        config.body = JSON.stringify({
          ...JSON.parse(serializeForm(this.form)),
          sections: this.cartNotification
            .getSectionsToRender()
            .map((section) => section.id),
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }

            this.cartNotification.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

// 1. Check if local confirm modal is present
// 2. Listen to add to cart click
// 3. Make body position: fixed
// 4. If "X" clicked, do not persist
// 5. Else persist add to cart if checkbox selected
